import createLucideIcon from '../createLucideIcon';
import type { LucideIconNode, LucideIconData } from '../types';

export const __iconData: LucideIconData = {
  name: 'file-database',
  size: 24,
  node: [
    ['path', { d: 'M12 12v8a5 2 0 01-10 0v-8', key: '1payun' }],
    ['path', { d: 'M12 16a5 2 0 01-10 0', key: '1gp1wi' }],
    ['path', { d: 'M14 2v5a1 1 0 001 1h5', key: '9v5fu7' }],
    [
      'path',
      {
        d: 'M4 6.3V4a2 2 0 012-2h8a2.4 2.4 0 011.706.706l3.588 3.588A2.4 2.4 0 0120 8v12a2 2 0 01-2 2h-2.43',
        key: '1wnzs2',
      },
    ],
    ['ellipse', { cx: '7', cy: '12', rx: '5', ry: '2', key: 'i6ea8s' }],
  ],
};

/**
 * @deprecated Access `__iconData` instead.
 */
export const __iconNode: LucideIconNode[] = __iconData.node;

/**
 * @component @name FileDatabase
 * @description Lucide SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMTIgMTJ2OGE1IDIgMCAwMS0xMCAwdi04IiAvPgogIDxwYXRoIGQ9Ik0xMiAxNmE1IDIgMCAwMS0xMCAwIiAvPgogIDxwYXRoIGQ9Ik0xNCAydjVhMSAxIDAgMDAxIDFoNSIgLz4KICA8cGF0aCBkPSJNNCA2LjNWNGEyIDIgMCAwMTItMmg4YTIuNCAyLjQgMCAwMTEuNzA2LjcwNmwzLjU4OCAzLjU4OEEyLjQgMi40IDAgMDEyMCA4djEyYTIgMiAwIDAxLTIgMmgtMi40MyIgLz4KICA8ZWxsaXBzZSBjeD0iNyIgY3k9IjEyIiByeD0iNSIgcnk9IjIiIC8+Cjwvc3ZnPgo=) - https://lucide.dev/icons/file-database
 * @see https://lucide.dev/guide/packages/lucide-react - Documentation
 *
 * @param {Object} props - Lucide icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const FileDatabase = createLucideIcon(__iconData);

export default FileDatabase;
